import { Method } from 'axios';

export class ApiConfig {
    url: string;
    method: Method;
    queryString?: string;
    data?: any;
    baseUrl?: string;
    header?: { [key: string]: string };
    additionalConfig?: any;
    constructor(
        _url = '',
        _method: Method = 'GET',
        _queryString = '',
        _data?: any,
        _baseUrl?: string,
        _header?: { [key: string]: string },
        _additionalConfig?: any
    ) {
        this.url = _url;
        this.method = _method;
        this.data = _data;
        this.queryString = _queryString;
        this.baseUrl = _baseUrl;
        this.header = _header;
        this.additionalConfig = _additionalConfig;
    }
}
